import React from "react";
import { Kortart, paymentTypes } from "../../../../utils/constants";
import {
  Col,
  FormGroup,
  Input,
  Label,
  Row,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import { LabelWithToolTip } from "../../../atoms/LabelWithToolTip";

const FikForm = (props) => {
  return (
    <FormGroup
      style={{
        display: props.checkbox === paymentTypes.FIK ? "block" : "none",
      }}
    >
      <FormGroup>
        <LabelWithToolTip
          id="labelKortart"
          labelText="Kortart *"
          tooltipText="Select the card type for FIK payments. Choose from available card types in the dropdown."
        />
        <select
          {...props.register("fikkortart")}
          className="form-control"
          name="fikkortart"
          onChange={props.handleKortartChange}
        >
          {Kortart?.map((item, index) => (
            <option key={item.key} value={item.value}>
              {item.name}
            </option>
          ))}
        </select>
      </FormGroup>
      <FormGroup
        style={{
          display: props.checkbox === paymentTypes.FIK ? "block" : "none",
        }}
      >
        <LabelWithToolTip
          id="labelKreditorGiro"
          labelText="Kreditor/GIRO *"
          tooltipText="Enter the creditor number or GIRO number for FIK payments. Must be 7 or 8 numeric characters. The + prefix is automatically added."
        />
        <Row>
          <Col sm="12">
            <InputGroup>
              
              <input
                type="text"
                {...props.register("fikNumber")}
                value={props.fikNumber}
                onChange={props.handleOnChangeFik}
                className="form-control"
              />                                                                                            
            </InputGroup>
          </Col>
        </Row>
        <div className={"text-danger"}>
          {props.errors.fikNumber && props.errors.fikNumber.type}
        </div>
      </FormGroup>
    </FormGroup>
  );
};

export default FikForm;
